import { createClient } from '@supabase/supabase-js';
import bcrypt from 'bcryptjs';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  },
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'apikey': supabaseAnonKey
  }
});

export const registerUser = async (formData) => {
  try {
    // First check if email exists
    const { data: existingUser } = await supabase
      .from('user_profiles')
      .select('email')
      .eq('email', formData.email)
      .single();

    if (existingUser) {
      throw new Error('Bu e-posta adresi zaten kullanımda');
    }

    // Check file size before upload
    if (formData.profilePhoto && formData.profilePhoto.size > 25 * 1024 * 1024) {
      throw new Error('Profil fotoğrafı 25MB\'dan küçük olmalıdır');
    }

    // Upload profile photo if exists
    let photoUrl = null;
    if (formData.profilePhoto) {
      const fileExt = formData.profilePhoto.name.split('.').pop();
      const fileName = `${Math.random().toString(36).substring(2)}.${fileExt}`;
      
      const { data, error: uploadError } = await supabase.storage
        .from('profile-photos')
        .upload(fileName, formData.profilePhoto, {
          cacheControl: '3600',
          contentType: formData.profilePhoto.type,
          upsert: false
        });

      if (uploadError) throw new Error(`Profil fotoğrafı yüklenemedi: ${uploadError.message}`);
      
      // Get public URL for the uploaded photo
      const { data: { publicUrl } } = supabase.storage
        .from('profile-photos')
        .getPublicUrl(data.path);
      
      photoUrl = publicUrl;
    }

    // Hash password if exists
    let hashedPassword = null;
    if (formData.password) {
      const salt = await bcrypt.genSalt(10);
      hashedPassword = await bcrypt.hash(formData.password, salt);
    }

    // Create user profile
    const { data, error } = await supabase
      .from('user_profiles')
      .insert([{
        email: formData.email,
        first_name: formData.firstName,
        last_name: formData.lastName,
        phone: formData.phone,
        country: formData.country,
        city: formData.city,
        address: formData.address,
        national_id: formData.tcNo,
        birth_date: formData.birthDate,
        gender: formData.gender,
        job_position: formData.position,
        website: formData.website,
        profile_photo_url: photoUrl,
        password_hash: hashedPassword,
        created_at: new Date().toISOString(),
        accepted_terms: formData.termsAccepted,
        accepted_kvkk: formData.kvkkAccepted,
        subscribed_newsletter: formData.newsletterSubscription,
        accepted_data_processing: formData.dataShareConsent
      }])
      .select()
      .single();

    if (error) throw error;
    return { success: true, data };

  } catch (error) {
    console.error('Registration error:', error);
    return { 
      success: false, 
      error: error.message || 'Kayıt işlemi başarısız oldu'
    };
  }
}; 